import type { CSSProperties } from 'react';

export const typeLabel: Record<string, string> = {
  client: 'Client Thread', internal: 'Internal', direct: 'Direct Message', org: 'Org Broadcast',
};

export const badgeStyle: Record<string, CSSProperties> = {
  client:   { background: 'rgba(29,158,117,.18)',  color: 'var(--v2)' },
  internal: { background: 'rgba(55,138,221,.15)',  color: 'var(--blue)' },
  direct:   { background: 'rgba(29,158,117,.15)',  color: 'var(--green)' },
  org:      { background: 'rgba(29,158,117,.15)',   color: 'var(--v2)' },
};
